import API from "./interceptor";

// ******************* Fetch upcoming appointments ******************
export const fetchUpcomingAppointments = async () => {
  try {
    const response = await API.get(`/api/receptionist/appointment/`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch upcoming appointments"
    );
  }
};

// ******************* Fecth allPataint Data *******************
export const fetchAllPateintData = async () => {
  try {
    const response = await API.get(`/api/doctor/get-all-users`);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch allPatient data";
  }
};

// *******************  Fetch OPD data *******************
export const fetchOpdData = async () => {
  try {
    const response = await API.get("/api/doctor/opd");
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch OPD data";
  }
};

// ******************* Fetch user(pateint) all details *******************
export const fetchUserAllDetails = async (loginUserID) => {
  try {
    const response = await API.get(
      `/api/users/user-all-details/${loginUserID}`
    );
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch details. Try again"
    );
  }
};

// ******************* Fetch Medical Profile details *******************
export const fetchMedicalProfileDetails = async (loginUserID) => {
  try {
    const response = await API.get(`/api/users/medical-details/${loginUserID}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message ||
      "Failed to fetch medical profile details. Try again"
    );
  }
};

// ===================== ADMIN USER MANAGEMENT APIs =====================

// ******************* Get All Users (Admin) *******************
export const fetchAllUsers = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    // Add filters to query params
    if (filters.role) params.append('role', filters.role);
    if (filters.status) params.append('status', filters.status);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.populate) params.append('populate', filters.populate);

    const queryString = params.toString();
    const endpoint = queryString 
      ? `/api/admin/users?${queryString}` 
      : '/api/admin/users';

    const response = await API.get(endpoint);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch users"
    );
  }
};

// ******************* Add New User (Admin) *******************
export const addUser = async (userData) => {
  try {
    const response = await API.post('/api/admin/users', userData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || 
      error?.response?.data?.errors?.[0] || 
      "Failed to create user"
    );
  }
};

// ******************* Update User (Admin) *******************
export const updateUser = async (userId, updateData) => {
  try {
    const response = await API.put(`/api/admin/users/${userId}`, updateData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || 
      error?.response?.data?.errors?.[0] || 
      "Failed to update user"
    );
  }
};

// ******************* Delete User (Admin) *******************
export const deleteUser = async (userId) => {
  try {
    const response = await API.delete(`/api/admin/users/${userId}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete user"
    );
  }
};

// ******************* Get Single User Details (Admin) *******************
export const fetchUserById = async (userId, populate = false) => {
  try {
    const endpoint = populate 
      ? `/api/admin/users/${userId}?populate=true`
      : `/api/admin/users/${userId}`;
      
    const response = await API.get(endpoint);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch user details"
    );
  }
};

// ******************* Bulk Update Users Status (Admin) *******************
export const bulkUpdateUsersStatus = async (userIds, status) => {
  try {
    const response = await API.patch('/api/admin/users/bulk-status', {
      userIds,
      status
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update users status"
    );
  }
};

// ******************* Get Users by Role (Admin) *******************
export const fetchUsersByRole = async (role, options = {}) => {
  try {
    const filters = { role, ...options };
    return await fetchAllUsers(filters);
  } catch (error) {
    throw (
      error?.response?.data?.message || `Failed to fetch ${role}s`
    );
  }
};

// ******************* Search Users (Admin) *******************
export const searchUsers = async (searchTerm, filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('search', searchTerm);
    
    // Add additional filters
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });

    const response = await API.get(`/api/admin/users/search?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to search users"
    );
  }
};

// ******************* Get User Statistics (Admin) *******************
export const fetchUserStatistics = async () => {
  try {
    const response = await API.get('/api/admin/users/statistics');
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch user statistics"
    );
  }
};

// ******************* Reset User Password (Admin) *******************
export const resetUserPassword = async (userId, newPassword) => {
  try {
    const response = await API.patch(`/api/admin/users/${userId}/reset-password`, {
      password: newPassword
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to reset user password"
    );
  }
};